var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.49892 10.3273L10.5473 3.61934C11.3271 2.87727 12.5543 2.88544 13.3241 3.63784L20.5334 10.6843C21.3439 11.4765 21.3349 12.7833 20.5135 13.5641L13.3612 20.3635C12.5736 21.1121 11.3324 21.095 10.5658 20.3249L3.46027 13.187C2.66859 12.3917 2.68603 11.1009 3.49892 10.3273Z",
    stroke: "#E69806",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.68377 11.9998C8.68377 12.5957 8.18631 13.0787 7.57266 13.0787C6.95901 13.0787 6.46155 12.5957 6.46155 11.9998C6.46155 11.4039 6.95901 10.9209 7.57266 10.9209C8.18631 10.9209 8.68377 11.4039 8.68377 11.9998ZM13.1281 11.9998C13.1281 12.5957 12.6306 13.0787 12.017 13.0787C11.4033 13.0787 10.9059 12.5957 10.9059 11.9998C10.9059 11.4039 11.4033 10.9209 12.017 10.9209C12.6306 10.9209 13.1281 11.4039 13.1281 11.9998ZM16.4613 13.0787C17.075 13.0787 17.5724 12.5957 17.5724 11.9998C17.5724 11.4039 17.075 10.9209 16.4613 10.9209C15.8477 10.9209 15.3502 11.4039 15.3502 11.9998C15.3502 12.5957 15.8477 13.0787 16.4613 13.0787Z",
    fill: "#E69806"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.6c8f17ebe6c474bf041b5b667d4feb46.svg";
export { ForwardRef as ReactComponent };